export enum Experiment {
  EnableEarnPointsLimits = 'enableEarnPointsLimits',
  EnablePointsAdjustment = 'enablePointsAdjustment',
}
